var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ComNavTop',{ref:"ComNavTop",attrs:{"fixed":_vm.fixed}}),_c('keep-alive',{attrs:{"include":['ViewBriefIntroduction','ViewAnnouncement']}},[_c('router-view')],1),_c('div',{staticClass:"footer"},[_vm._v("Copyright © 2022  广西北部湾国际港务集团有限公司  技术支持：广西北港大数据科技有限公司")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }